
const codeMessages =

    {
        'code-500': 'Ocurrió un error al procesar la solicitud.',
        'code-200': 'Solicitud procesada con éxito.',
        'code-store': 'Registro guardado con éxito.',
        'code-edit': 'Registro editado con éxito.',
        'code-delete': 'Registro eliminado con éxito.',
        'code-no-delete': 'Registro seleccionado no se pudo eliminar.',

    }

export default codeMessages
